import React from "react";
import Navbar from "../Layout/Navbar";
import {compose} from "redux";
import {firestoreConnect} from "react-redux-firebase";
import {connect} from "react-redux";
import {Col, Row, Spin, Button, Drawer, Form, TimePicker, List, Tabs, Layout, Menu, Breadcrumb, Avatar} from "antd";
import {updateWorkingHours} from "../../Store/Actions/shop";
import {
    ShoppingCartOutlined,
    GlobalOutlined,
    ClockCircleOutlined,
    PhoneOutlined
} from '@ant-design/icons';
import "./shop.css"
import ShopItems from "./ShopItems";
import General from "./General";
import Branches from "./Branches";
import CustomMap from "../Map/Map";
import WorkingHours from "./Hours";
import Contacts from "./Contacts";
const { Sider } = Layout;


class Shop extends React.Component {

    state = {
        collapsed: true,
        selected: "items"
    };

    onCollapse = collapsed => {
        this.setState({ collapsed });
    };

    onSelect = selected => {
        this.setState({
            selected: selected.key
        });
    }

    onClose = () => {
        this.setState({
            hoursVisible: false
        })
    };

    updateWorkingHours = values => {
        let hours = {};
        Object.entries(values).forEach(day => {
            if(day[1]){
                hours[day[0]] = {
                    start: new Date(day[1][0]).getHours()*3600 + new Date(day[1][0]).getMinutes()*60,
                    end: new Date(day[1][1]).getHours()*3600 + new Date(day[1][1]).getMinutes()*60
                }
            }
        });
        updateWorkingHours(this.props.shop.id, hours, () => {
            this.setState({
                hoursVisible: false
            })
        });
    };



    render() {
        const { shop } = this.props;
        const { hoursVisible, selected } = this.state;
        const today = ["sunday","monday", "tuesday", "wednesday", "thursday", "friday", "saturday"][new Date().getDay()];

        const views = {
            "items": <ShopItems shop={shop} />,
            "general": <General shop={shop} />,
            "branches": <Branches shop={shop} />,
            "hours": <WorkingHours shop={shop} />,
            "contacts": <Contacts shop={shop} />
        }

        if(!shop) {
            return <Spin />
        }
        return(
            <div>
                <div>
                    <Layout style={{ minHeight: 'calc(100vh - 48px)' }}>
                        <Sider  collapsible collapsed={this.state.collapsed} onCollapse={this.onCollapse}>
                            <div>
                                <Menu selectedKeys={[selected]} onSelect={this.onSelect} defaultSelectedKeys={['1']} mode="inline">
                                    <Menu.Item key="general" icon={<Avatar className="anticon" src={ shop.logo } />}>
                                        { shop.title }
                                    </Menu.Item>
                                    <Menu.Item key="items" icon={<ShoppingCartOutlined />}>
                                        Items
                                    </Menu.Item>
                                    <Menu.Item icon={<GlobalOutlined />} key="branches">Branches</Menu.Item>
                                    <Menu.Item icon={<ClockCircleOutlined />} key="hours">Working hours</Menu.Item>
                                    <Menu.Item icon={<PhoneOutlined />} key="contacts">Contacts and social media</Menu.Item>
                                </Menu>
                            </div>

                        </Sider>
                        <Layout className="site-layout uk-padding">
                            <div className={ selected==="branches" ? "uk-background-default uk-border-rounded" : "uk-background-default uk-border-rounded uk-padding"}>
                                { views[selected] }
                            </div>
                        </Layout>
                    </Layout>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state, props) => {


    return {
        auth: state.firebase.auth,
        shop: state.firestore.ordered.shops ? state.firestore.ordered.shops.find(shop => shop.id === props.match.params.id) : null
    }
}

const enhance = compose(
    firestoreConnect((props) => [
        { collection: "shops", doc: props.match.params.id }
    ]),
    connect(mapStateToProps)
);
export default enhance(Shop);



// WEBPACK FOOTER //
// ./src/Components/Shop/Shop.js